import { shouldUseStoredAccessToken } from "./authMode";

const ACCESS_TOKEN_STORAGE_KEY = "token";

export function getAccessToken() {
    if (!shouldUseStoredAccessToken()) {
        sessionStorage.removeItem(ACCESS_TOKEN_STORAGE_KEY);
        return null;
    }

    return sessionStorage.getItem(ACCESS_TOKEN_STORAGE_KEY);
}

export function setAccessToken(token) {
    if (!shouldUseStoredAccessToken()) {
        sessionStorage.removeItem(ACCESS_TOKEN_STORAGE_KEY);
        return;
    }

    if (token == null) {
        sessionStorage.removeItem(ACCESS_TOKEN_STORAGE_KEY);
        return;
    }

    sessionStorage.setItem(ACCESS_TOKEN_STORAGE_KEY, token);
}

export function clearAccessToken() {
    sessionStorage.removeItem(ACCESS_TOKEN_STORAGE_KEY);
}

